import { KUnit, VaUnit } from '@/custom/menicon/models';

export const lensParametersUnits = {
  Addition: ' D',
  BackCylinder: ' D',
  BackCylinderAxis: 'º',
  Diameter: ' mm',
  EdgeLift: ' mm',
  FrontCylinder: ' D',
  FrontCylinderAxis: 'º',
  Height: ' mm',
  HeightFlat: ' mm',
  HeightSteep: ' mm',
  LensTotalHeight: ' mm',
  Power: ' D',
  Prism: ' pD',
  Radius: ' mm',
  RadiusFlat: ' mm',
  RadiusSteep: ' mm',
  SkirtRadius: ' mm',
  Tangent: 'º',
  TangentFlat: 'º',
  TangentSteep: 'º',
  Vault: ' µm'
};

export const kUnits: string[] = [KUnit.MM, KUnit.DIOPTRES];
export const vaUnits: string[] = [VaUnit.SIX_SIX, VaUnit.TWENTY_TWENTY, VaUnit.DECIMAL, VaUnit.LOG_MAR, VaUnit.MONOYER];
